export default __webpack_public_path__ + "static/media/BackgroundPwa.aad6ba4e.png";